import { useEffect } from "react";

export default function HideAssistantHeroSection() {
  useEffect(() => {
    const hideAssistantHero = () => {
      const textMatches = [
        "your automation starts with a conversation",
        "tu automatización empieza con una conversación",
        "tell our ai assistant",
        "cuéntale a nuestro asistente",
        "open ai assistant",
        "abrir asistente ia",
        "start ai consultation",
        "iniciar consulta con ia",
      ];

      const elements = Array.from(
        document.querySelectorAll("section, main > div, main section, .hero, [class*='hero']")
      );

      elements.forEach((element) => {
        const text = (element.textContent || "").toLowerCase();

        const isAssistantHero = textMatches.some((match) => text.includes(match));

        if (!isAssistantHero) return;

        const isBusinessTools =
          element.id === "business-tools" || element.closest("#business-tools");

        if (isBusinessTools) return;

        element.style.display = "none";
        element.setAttribute("data-hidden-assistant-hero", "true");
      });
    };

    hideAssistantHero();

    const observer = new MutationObserver(hideAssistantHero);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return null;
}
